<template>
  <ArrowUpIcon class="rotate-90" />
</template>

<script setup lang="ts">
import ArrowUpIcon from './ArrowUpIcon.vue'
</script>
